import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import OrderMoney from '@square/dashboard-data/models/subscriptions/order-money';
export default ProtoBaseModel.extend({
  // the proto is returning "currency" instead of "currencyCode"
  amountMoney: attr(OrderMoney),
  exchangeRate: attr(String)
});